import React from 'react';

const ReviewsIcon = (props) => {
  return (
    <svg {...props} id="reviews-icon" viewBox="0 0 700 700" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M175 175H525V245H175V175ZM175 315H420V385H175V315Z" fill="url(#paint0_linear)"/>
    <path d="M175 175H525V245H175V175ZM175 315H420V385H175V315Z" fill="url(#paint1_linear)"/>
    <path d="M630 0H70C31.395 0 0 31.395 0 70V700L186.655 560H630C668.605 560 700 528.605 700 490V70C700 31.395 668.605 0 630 0ZM630 490H163.345L70 560V70H630V490Z" fill="url(#paint2_linear)"/>
    <path d="M630 0H70C31.395 0 0 31.395 0 70V700L186.655 560H630C668.605 560 700 528.605 700 490V70C700 31.395 668.605 0 630 0ZM630 490H163.345L70 560V70H630V490Z" fill="url(#paint3_linear)"/>
    <defs>
    <linearGradient id="paint0_linear" x1="350" y1="175" x2="350" y2="385" gradientUnits="userSpaceOnUse">
    <stop stopColor="#10CD3A"/>
    <stop offset="1" stopColor="#8BD513"/>
    </linearGradient>
    <linearGradient id="paint1_linear" x1="350" y1="175" x2="350" y2="385" gradientUnits="userSpaceOnUse">
    <stop stopColor="#C5D22A"/>
    <stop offset="1" stopColor="#F5775B"/>
    </linearGradient>
    <linearGradient id="paint2_linear" x1="350" y1="0" x2="350" y2="700" gradientUnits="userSpaceOnUse">
    <stop stopColor="#10CD3A"/>
    <stop offset="1" stopColor="#8BD513"/>
    </linearGradient>
    <linearGradient id="paint3_linear" x1="350" y1="0" x2="350" y2="700" gradientUnits="userSpaceOnUse">
    <stop stopColor="#C5D22A"/>
    <stop offset="1" stopColor="#F5775B"/>
    </linearGradient>
    </defs>
    </svg>
  );
}


export { ReviewsIcon };
